import React from 'react';
import { Container, Image, Stack, Heading } from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';
import Hero from '../../components/sections/hero';
import SimpleThreeColumns from '../../components/sections/simplethreecolums';
import SimpleTwoColumns from '../../components/sections/simpletwocolumns';
import HeroWithLeftMedia from '../../components/sections/herowithleftmedia';

import gertCloudsCard from '../../components/ui/gert-clouds-card.png';
import mainHeroImage from '../../components/ui/main-hero.jpg';

function Home() {
  return (
    <HomeLayout align="center">
      <Stack w="full" pt="90px">
        <Hero
          title={<Heading as='h1'>We connect active people with their passions.</Heading>}
          backgroundImage={mainHeroImage}/>
      </Stack>
      <Container maxW='6xl' my={14}>
        <SimpleThreeColumns />
        <SimpleTwoColumns />
        <HeroWithLeftMedia
          title="IN MEMORY OF OUR TOUGH MOTHER, GERT BOYLE"
          subTitle="It is with great sadness that we announce the passing of Gert Boyle, the Chairman of the Board of Directors of Columbia Sportswear Company and its matriarch since 1970. Our “One Tough Mother” held many jobs at Columbia, from seamstress of the first fishing vest to President to advertising icon. Her sharp wit and wisdom helped propel the company from near bankruptcy in the early ‘70s to the global multi-brand company it is today, with annual net sales of almost $3 billion in 2018. Her pioneering role as a woman in what was then a male-dominated industry is a testament to her strength of character and ability to persevere through difficult situations."
          // cta={<Button size="lg" px={6} bg="#333" color="white">Read More</Button>}
          media={<Image src={gertCloudsCard} borderRadius={10} />}
        />
      </Container>  
    </HomeLayout>
  );
}

export default Home;
